export const TRIAGE_OPTIONS = [
	{ value: 0, label: 'Czarny', colorClass: 'bg-gray-900 text-white' },
	{ value: 1, label: 'Granatowy', colorClass: 'bg-indigo-950 text-white' },
	{ value: 2, label: 'Niebieski', colorClass: 'bg-blue-600 text-white' },
	{ value: 3, label: 'Zielony', colorClass: 'bg-green-600 text-white' },
	{ value: 4, label: 'Żółty', colorClass: 'bg-yellow-400 text-gray-900' },
	{ value: 5, label: 'Czerwony', colorClass: 'bg-red-600 text-white' },
]

export const getTriageOption = triage => {
	const numericTriage = Number(triage)
	return TRIAGE_OPTIONS.find(option => option.value === numericTriage) || null
}

export const getTriageLabel = triage => getTriageOption(triage)?.label || '-'
